import apiClient from '../axios';

export default {
    getComentarioPorLeccion(id) {
        return apiClient.get(`/comentarios/leccion/${id}`);
    },

};